import { useMutation } from '@tanstack/react-query';
import { sendEmailVerification } from 'Services/VerifyEmail/EmailVerification';
import {
  SendEmailVerificationError,
  SendVerificationError,
  SendVerificationResponse,
} from '../ResendEmailVerification.types';

export const useSendEmailVerification = () => useMutation<
  SendVerificationResponse,
  SendVerificationError,
  string
>({
  mutationFn: async (userId: string) => {
    const response = await sendEmailVerification({ userId });
    const isSuccessResponse = (response && response.status === 'success') || false;

    if (!isSuccessResponse) {
      return Promise.reject(new SendEmailVerificationError('Could not send email verification'));
    }

    return {
      sendVerificationMessage: response.data.message as string,
      sendVerificationSecondsLeft: response.data.seconds_left as number,
    };
  },
  mutationKey: ['SEND_EMAIL_VERIFICATION'],
});
